import Card from '@/components/Card/Card';
import CardHeader from '@/components/Card/CardHeader';
import CustomInput from '@/components/CustomInput/CustomInput';
import GridContainer from '@/components/Grid/GridContainer';
import GridItem from '@/components/Grid/GridItem';
import loader from '../../assets/img/loader.svg';
import Button from '@/components/CustomButtons/Button';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import CardBody from '@/components/Card/CardBody';
import { API_BASE_URL } from '@/config';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { loadMoov } from '@moovio/moov-js';

export default function AddMoovPaymentMethod() {
  const { t } = useTranslation();
  const [loaded, setLoaded] = useState(false);
  const [formInputs, setFormInputs] = useState({
    accountHolderName: '',
    accountNumber: '',
    routingNumber: '',
    accountType: 'business',
    bankAccountType: 'checking',
    accountId: '',
  });
  const [moovAccounts, setMoovAccounts] = useState([]);

  const [message] = useState('');
  const onInputChange = (e) => {
    const { name, value } = e.target;
    setFormInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  const addMoovPaymentMethod = async (e) => {
    try {
      e.preventDefault();
      setLoaded(true);
      const token = (
        await axios.post(API_BASE_URL + '/getTokenToAddPaymentMethod', {
          moovAccountId: formInputs.accountId,
        })
      ).data.token;

      const moov = await loadMoov(token);
      console.log(moov);
      const bankAccount = {
        holderName: formInputs.accountHolderName,
        holderType: formInputs.accountType,
        accountNumber: formInputs.accountNumber,
        bankAccountType: formInputs.bankAccountType,
        routingNumber: formInputs.routingNumber,
      };
      const response = await moov.accounts.bankAccounts.link({
        accountID: moovAccounts.find((acc) => formInputs.accountId == acc.id)
          .account_id,
        bankAccount,
      });

      await axios.post(API_BASE_URL + '/addPaymentMethodToDB', {
        holderName: response.holderName,
        bankAccountID: response.bankAccountID,
        moovAccountId: formInputs.accountId,
      });
      setLoaded(false);
      navigate('/admin/MoovPage');
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    axios.get(API_BASE_URL + '/getMoovAccounts').then((res) => {
      console.log(res.data);
      setMoovAccounts(res.data);
    });
  }, []);

  const cancelfrm = () => {
    navigate('/admin/MoovPage');
  };

  return (
    <div>
      <form onSubmit={addMoovPaymentMethod}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color='primary'>
                <h4>{t('addMoovPaymentMethod.title')}</h4>
              </CardHeader>
              <CardBody>
                {loaded && (
                  <div className='loaders'>
                    <img src={loader} />
                  </div>
                )}

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-tango'>
                          {t('addMoovPaymentMethod.fields.moovAccount')}
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-tango'
                          id='demo-simple-select'
                          value={formInputs.accountId}
                          onChange={onInputChange}
                          name='accountId'
                          className='full-width-elem'>
                          {moovAccounts.map((obj) => (
                            <MenuItem key={obj && obj.id} value={obj && obj.id}>
                              {obj && obj.account_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      type='text'
                      labelText={t(
                        'addMoovPaymentMethod.fields.accountHolderName',
                      )}
                      onChange={onInputChange}
                      value={formInputs.accountHolderName}
                      name='accountHolderName'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-tango'>
                          {t('addMoovPaymentMethod.fields.accountType')}
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-tango'
                          id='demo-simple-select'
                          value={formInputs.accountType}
                          onChange={onInputChange}
                          name='accountType'
                          className='full-width-elem'>
                          <MenuItem value='individual'>
                            {t('addMoovPaymentMethod.accountTypes.individual')}
                          </MenuItem>
                          <MenuItem value='business'>
                            {t('addMoovPaymentMethod.accountTypes.business')}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-tango'>
                          {t('addMoovPaymentMethod.fields.bankAccountType')}
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-tango'
                          id='demo-simple-select'
                          value={formInputs.bankAccountType}
                          onChange={onInputChange}
                          name='bankAccountType'
                          className='full-width-elem'>
                          <MenuItem value='savings'>
                            {t('addMoovPaymentMethod.bankAccountTypes.savings')}
                          </MenuItem>
                          <MenuItem value='checking'>
                            {t(
                              'addMoovPaymentMethod.bankAccountTypes.checking',
                            )}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('addMoovPaymentMethod.fields.routingNumber')}
                      name='routingNumber'
                      onChange={onInputChange}
                      value={formInputs.routingNumber}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('addMoovPaymentMethod.fields.accountNumber')}
                      name='accountNumber'
                      onChange={onInputChange}
                      value={formInputs.accountNumber}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>

                {message && (
                  <GridContainer>
                    <GridItem xs={8} sm={8} md={6}>
                      <p style={{ color: 'red', padding: '10px 0' }}>
                        {message}
                      </p>
                    </GridItem>
                  </GridContainer>
                )}
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <Button color='primary' type='submit'>
                      {t('addMoovPaymentMethod.buttons.create')}
                    </Button>
                    <Button
                      color='primary'
                      onClick={cancelfrm}
                      className='btn-cancel'
                      style={{ marginLeft: '5px' }}>
                      {t('addMoovPaymentMethod.buttons.cancel')}
                    </Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </form>
    </div>
  );
}
